<template>
    <div class="deground">
        <headerpage :status="4"></headerpage>
        <div class="box" :style="{height:height+'px'}">
            <img :src="common.local_pic | addurl" style="width: 100%;height: 100%;position: absolute;top: 0;" />
            <img src="../../assets/images/qie/10.png" class="box_top_img" />
        </div>
        <div class="adaptation">
            <div class="box1">
                <div class="box1_top">
                    <div class="box1_top_heng"></div>
                </div>
            </div>
        </div>
        <div style="height: 30px;"></div>
        <div class="box2 adaptation" style="background-color: #f6f8f7;" v-loading="loading">

            <div class="box2_left">
                <div class="bg-white" style="padding: 30px 40px;border-radius: 10px;margin-bottom: 20px;">
                    <div class="box1_header" style="margin-bottom: 30px;">
                        <div class="box1_header_shu"></div>
                        <div class="box1_header_text">政策数据库</div>
                    </div>
                    <div class="box2_until">
                        <div v-for="(item, index) in tablist" :key="index" class="borbot" style="margin-bottom: 10px" v-if="item.id !== '-1'">
                            <!--  -->
                            <div class="box2_until_center ">
                                <div class="box2_until_left">{{item.name}}:</div>
                                <div class="box2_cent ">
                                    <div v-for="(citem, cindex) in item.union_type" @click="tabchange(index,cindex,citem.id,item.id)" class="box2_until_right cpoint"
                                        :class="citem.sty? 'sty' : ''">
                                        {{citem.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="" style="padding-bottom: 10px">
                            <div class="box2_until_center">
                                <div class="box2_until_left" style="line-height: 40px; width: 65px">
                                    关键词:
                                </div>
                                <div class="box2_cent"
                                    style="padding-left: 22px;display: flex;justify-content: flex-start;">
                                    <el-input @change="tosearch" v-model="keyword" placeholder="请输入关键词"
                                        style="width: 300px; margin-right: 15px"></el-input>
                                    <el-button type="primary" @click="tosearch"
                                        style="background: #0070c0; border-color: #0070c0" >搜索</el-button>
                                    <el-button @click="chong"
                                         >重置</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tablecss" style=" padding: 20px;margin-top: 14px;background-color: #fff;border-radius: 8px;">

                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column prop="title" label="政策名称" width="300px">
                        </el-table-column>
                        <!-- <el-table-column prop="hangye" label="行业划分">
                        </el-table-column> -->
                        <el-table-column prop="fabudanwei" label="发布单位">
                        </el-table-column>
                        <el-table-column prop="fabushijian" label="发布时间">
                        </el-table-column>
                        <el-table-column prop="wenjiandengji" label="文件等级">
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <div class="detaii" @click="jumpdetail(scope.row.id)" >查看详情</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="adaptation pagecss">
                    <el-pagination
                  background
                  :page-size="pagesize"
                  :hide-on-single-page="true"
                  layout="prev, pager, next"
              
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :total="totalnum"
                >
                </el-pagination>
                </div>
                <div style="height: 40px;"></div>

            </div>
        </div>
    </div>
</template>
  
<script>
import headerpage from '../../components/header/header.vue';
import windowchange from '@/util/window'
import { mapGetters } from 'vuex'
export default {
    components: {headerpage},
    mixins: [windowchange],
    computed: {
			...mapGetters({
				common: 'user/common', 
			}),
		},
    data() {
        return {
            first: "",
            second: "",
            third: "",
            four: "",
            tableData: [],
            keyword: '',
            ttt: false,
            tablist: [
            ],
            pagesize: 20,
            currentPage: 1,
            totalnum:0,
            loading:true,
        }
    },
    methods: {
        chong(){
            var that = this
            var tablist = JSON.parse(JSON.stringify(this.tablist))
            tablist.map($trt=>{
                $trt.union_type.map((res) => {
                res.sty = false;
               });
               $trt.union_type[0].sty = true
            })
            that.tablist = tablist
            that.currentPage = 1
            that.first= "",
            that.second= "",
            that.third= "",
            that.four= "",
            that.tableData= [],
            that.keyword= ''
            this.depotList();
        },
        tabchange(index,cindex,id,topid){
            var tablist = JSON.parse(JSON.stringify(this.tablist))
            tablist[index].union_type.map((res) => {
                res.sty = false;
            });
            // console.log(index,cindex,id,topid)
            if (topid == 2) {
                this.first = id;
            } else if (topid == 3) {
                this.second = id;
            } else if (topid == 4) {
                this.third = id;
            } else if (topid == 55) {
                this.four = id;
            }
            tablist[index].union_type[cindex].sty = true
            this.tablist = tablist
            this.depotList();
        },
        
        typeList(type){
            var api = this.$api.api.index.typeList;
            this.$https.post({
                api: api,
                type: "formData",
            }, {
               
            }, (response) => {
                var data = response.data
                for(var i=0;i<data.length;i++){
                    data[i].union_type.unshift({
                        name: "全部",
                        id: 0,
                        sty:true
                    })
                } 
                this.tablist = data
            }, (error) => {
                console.log(error);
            });
        },
        handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage;
            this.depotList();
        },
        depotList(){
            this.loading = true
            var api = this.$api.api.index.depotList;
            this.$https.post({
                api: api,
                type: "formData",
            }, {
                first: this.first,
                second: this.second,
                third: this.third,
                four: this.four,
                keyword: this.keyword,
                page: this.currentPage,
                page_size: this.pagesize,
            }, (response) => {
                // console.log('12333333333333',response.data)
                this.totalnum = response.count;
                this.tableData = response.data;
                this.loading = false
            }, (error) => {
                console.log(error);
            });
        },
        tosearch() {
                this.currentPage = 1
                this.tableData = []
                this.depotList()
        },
        jumpdetail(id){
            let routeUrl = this.$router.resolve({
                name: "policydetail",
                 query: { id: id }
            });
            window.open(routeUrl.href);
            // this.$router.push({ name: 'policydetail', query: {id: id } });
        }
    },
    created: function () {
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
        }
        this.typeList()
        this.depotList()
    }
}
</script>
<style lang="scss">




.pagecss .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: #f6f8f7;
    color: #999999;
    margin: 0 5px;

}

.pagecss .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #206ad9;
    border-radius: 4px;
}

.pagecss .el-icon-arrow-left {
    margin-right: 10px;
}

.pagecss .el-icon-arrow-left:before {
    content: '上一页'
}

.pagecss .el-icon-arrow-right {
    margin-left: 10px;
}

.pagecss .el-icon-arrow-right:before {
    content: '下一页'
}

.pagecss {

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        background-color: #f6f8f7;
    }
}
</style>


<style scoped>
.box {
    background-size: 100% 100%;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.box_top_img {
    width: 905px;
    /* height: 51px; */
    position: absolute;
    top: 12%;
}

.box2 {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.box2_left {
    /* width: 70%; */
    /* width: 1064px; */
    width: 100%;
    border-radius: 10px;
}

.box2_until_center {
    display: flex;
}

.box2_until_left {
    font-size: 14px;
    color: #959595;
    width: 65px;
    line-height: 28px;
}

.box2_until_right {
    height: 28px;
    font-size: 14px;
    line-height: 28px;
    padding: 0 8px;
    color: #4e4e4e;
    margin-left: 22px;
    margin-bottom: 10px;
}

.borbot {
    border-bottom: 1px solid #eee;
}

.box2_cent {
    display: flex;
    width: 93%;
    flex-wrap: wrap;
    min-height: 38px;
}

.box2_height1 {
    max-height: 380px;
    overflow: hidden;
}

.box5 {
    width: 100%;
    display: flex;
    min-height: 50px;
    border-bottom: 1px solid #f1f1f1;
}

.box5_text1 {
    width: 31%;
    display: flex;
    align-items: center;
    border-right: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    padding: 5px;
}

.box5_text2 {
    width: 14%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    padding: 5px;
}

.box5_text3 {
    width: 13%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    padding: 5px;
}

.sty {
    color: #ffffff;
    background: #0070c0;
}

.box2_cc {
    color: #ffffff;
    background-color: #0070c0;
}

.box2_nei {
    /* width: 95px; */
    height: 30px;
    padding: 0 15px;
    /* background-color: #ff6c00; */
    background-color: #0160a3;
    color: #ffffff;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.oneleft {
    width: 99px;
    height: 99px;
}

.oneleft img {
    width: 99px;
    height: 99px;
    border-radius: 10px;
}

.oneright {
    margin-top: 10px;
    width: 77%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
}

.oneright p {
    font-size: 14px;
    color: #292a2d;
    font-weight: 400;
    padding-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 214px;
}

.oneright span {
    display: inline-block;
    padding: 2px 8px;
    font-size: 12px;
    color: #fff;
    font-weight: 400;
    background: #36a6f7;
    border-radius: 2px;
}

.likeone {
    height: auto;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 25px;
}

.likeone:hover {
    /* background: #f6f7fb;
  box-shadow: 0 6px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 2px;
  z-index: 9;
  position: relative; */
}

.likeone:last-child {
    margin-bottom: 0px;
}

.rightbtn {
    color: #fff;
    background-color: #0160a3;
    border-radius: 7px;
    text-align: center;
    /* margin-bottom: 10px; */
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    width: 140px;
}

.rightbtn:last-child {
    margin-bottom: 0px;
}

.cright {
    position: sticky;
    /* top: 166px; */
    top: 20px;
}

.copen {
    color: #0160a3;
    font-weight: 600;
    padding-bottom: 20px;
}

.box1_header {
    /* height: 77px; */
    display: flex;
    align-items: center;
}

.box1_header_text {
    font-size: 20px;
    color: #191919;
    margin-left: 10px;
    font-weight: 600;
}

.box1_header_shu {
    width: 4px;
    height: 21px;
    background-color: #0070c0;
}

.pagecss {
    background-color: #f6f8f7;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px auto;
    margin-bottom: 0;
}

.detaii {
    padding: 8px;
    color: #fff;
    background-color: #0170c1;
    border-radius: 10px;
    text-align: center;
    width: 80%;
    margin: 0 auto;
    cursor: pointer;
}
</style>
  


// WEBPACK FOOTER //
// policy.vue?3904e04b